// removed by extract-text-webpack-plugin
module.exports = {"brokerageContainer":"src-pages----brokerage-module---brokerageContainer---3kAXj","topAnchor":"src-pages----brokerage-module---topAnchor---3qqMa","stdContent":"src-pages----brokerage-module---stdContent---cZfhF","left":"src-pages----brokerage-module---left---2sDlH","right":"src-pages----brokerage-module---right---2_Zf5","section":"src-pages----brokerage-module---section---2TnIt","callout":"src-pages----brokerage-module---callout---2kWe1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/brokerage.module.less
// module id = 272
// module chunks = 70392746020482